import * as React from 'react';
import '../../style/PasswordResetCode.css';

var CODE_LENGTH = new Array(6).fill(0);

interface ResetComponentProps extends React.Props<any> {
	getValue() : string
};

interface styleProp {
	className?: string
}

interface ResetComponentState extends React.Props<any> {
	value: string, focused: boolean
};

class InputComponent extends React.Component<styleProp, ResetComponentState> {
	input: React.RefObject<HTMLInputElement>;

	constructor(props: any) {
		super(props);
		this.input = React.createRef<HTMLInputElement>();
		this.state = {
			value: "",
			focused: false
		};
	}

	getValue() {
		return this.state.value;
	}

	render() {
		var CODE_LENGTH = new Array(6).fill(0);

		let { value, focused } = this.state;
		let values = value.split("");
		const selectedIndex =
			values.length < CODE_LENGTH.length ? values.length : CODE_LENGTH.length - 1;

		const hideInput = !(values.length < CODE_LENGTH.length);
		const handleClick = () => {
			this.input.current?.focus();
		};
		const handleFocus = () => {
			this.setState({ focused: true });
		};
		const handleBlur = () => {
			this.setState({
				focused: false,
			});
		};
		const handleKeyUp = (e: { key: string; }) => {
			if (e.key === "Backspace") {
				this.setState(state => {
					return {
						value: state.value.slice(0, state.value.length - 1),
					};
				});
			}
		};
		const handleChange = (e: { target: { value: any; }; }) => {
			const value = e.target.value;
			this.setState(state => {
				if (state.value.length >= CODE_LENGTH.length) return null;
				return {
					value: (state.value + value).slice(0, CODE_LENGTH.length),
				};
			});
			console.log(values)
		};

		return (
			<div className="InputComponent">
				<div className="wrap" onClick={handleClick}>
					<input
						value=""
						ref={this.input}
						onChange={handleChange}
						onKeyUp={handleKeyUp}
						onFocus={handleFocus}
						onBlur={handleBlur}
						className="input"
						
						style={{
							width: "32px",
							top: "0px",
							bottom: "0px",
							left: `${selectedIndex * 32}px`,
							opacity: hideInput ? 0 : 1,
						}}
					/>
					{CODE_LENGTH.map((v, index) => {
						const selected = values.length === index;
						const filled = values.length === CODE_LENGTH.length && index === CODE_LENGTH.length - 1;

						return (
							<div key={index} className={this.props.className}>
								{values[index]}
								{(selected || filled) && focused && <div key={index} className="shadows" />}
							</div>
						
						);
					})}
				</div>
			</div>
		);
	}
}
export default InputComponent;